var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.833.833a3 3 0 0 1 3 3v.333h.834a3.333 3.333 0 0 1 3.328 3.151L20 7.5v5.833a3.335 3.335 0 0 1-2.5 3.229v2.41l-3.842-2.305H8.333a3.335 3.335 0 0 1-3.228-2.5H3.833a3 3 0 0 1-3-3V3.833a3 3 0 0 1 3-3h9zm3.834 5h-.826l-.007.091v5.243a3 3 0 0 1-3 3H6.89c.289.498.827.833 1.443.833h5.787l1.713 1.028V15h.834c.92 0 1.666-.746 1.666-1.667V7.5c0-.92-.746-1.667-1.666-1.667zm-5 2.5H5a.833.833 0 0 0-.105 1.66L5 10h6.667a.833.833 0 1 0 0-1.667zm0-3.333H5a.833.833 0 0 0-.105 1.66L5 6.667h6.667a.833.833 0 0 0 0-1.667z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.038e2aa5.svg";
export { ForwardRef as ReactComponent };